exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".edu-application-modal .input-area input[type=email],.edu-application-modal .input-area input[type=number],.edu-application-modal .input-area input[type=password],.edu-application-modal .input-area input[type=text],.edu-application-modal .input-area select,.edu-application-modal .input-area textarea,.edu-application-modal textarea{border-color:#767676}.edu-application-modal .check-wrap input[type=checkbox]:not(:checked)+label:before{background-image:none;background-color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-0e4aa4b1","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/main/education/EduApplicationModal.vue
// module id = 769
// module chunks = 6